import { gql } from 'graphql-request'
import { DynamicBlockZone } from '../../../lib/strapi/dynamicBlockZones'
import { SelectInputData, SelectInput } from '../../SelectInput'

export type SelectInputZoneType = DynamicBlockZone<
  'ComponentPowInputFieldsSelectInput',
  Omit<SelectInputData, 'register'>
>

export const SelectInputFragment = gql`
... on ComponentPowInputFieldsSelectInput {
  __typename
  label
  dataLabel
  options {
    label
    value
  }
}
`

const SelectInputZone = (props: SelectInputData) => {

  return (
    <SelectInput {...props}/>
  )
}

export default SelectInputZone
